import React from 'react';

import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import awsconfig from './aws-exports';

import "./index.css"

import Map from "./components/map/view/MapProvider"

export const client = new AWSAppSyncClient({
    url: awsconfig.aws_appsync_graphqlEndpoint,
    region: awsconfig.aws_appsync_region,
    auth: {
        type: AUTH_TYPE.API_KEY,
        apiKey: awsconfig.aws_appsync_apiKey,
    },
    disableOffline: true
});

function App() {
    return (
        <Map />
    );
}

export default App;
